module.exports = __webpack_public_path__ + "static/img/feature-1.027295e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature-1.png
// module id = jEGb
// module chunks = 1